import { createTheme } from '@mui/material/styles'
import { buttonClasses } from '@mui/material/Button'

const theme = createTheme({
  palette: {
    primary: {
      main: '#2475FF',
    },
    secondary: {
      main: '#FF7A00',
    },
    action: {
      disabledBackground: '#B8C7FF',
      disabled: '#ffffff',
    },
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
  },

  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderBottom: '1px #D3D3D3 dotted',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {},
        sizeLarge: {
          backgroundColor: '#2475FF',
          color: 'white',
          border: '1px solid;',
          borderColor: 'black',
          '&:hover': {
            backgroundColor: '#2475ff',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 20,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {},
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        sizeSmall: {},
        root: {
          borderRadius: '20px!important',
          '&.Mui-disabled > fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.23) !important',
          },
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        root: {},
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          paddingTop: '10px',
          paddingBottom: '10px',
          color: 'black',
          fontSize: 14,

          backgroundColor: '#fae83c',
        },

        arrow: {
          color: '#fae83c',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlinedPrimary: {
          backgroundColor: 'white',
        },

        filledPrimary: {
          backgroundColor: 'white',
        },

        filledSecondary: {
          color: 'white',
        },

        filled: {
          color: '#2475FF',
          fontWeight: 600,
        },

        root: {
          height: 24,
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          [`&.${buttonClasses.disabled}`]: {
            border: 'none',
            backgroundColor: '#B8C7FF',
          },
          textTransform: 'unset',
        },

        textPrimary: {
          borderRadius: 20,
          fontWeight: 'bold',
          borderColor: 'black',
        },

        sizeMedium: {
          fontWeight: 'bold',
          height: 48,
          borderRadius: 15,
          fontSize: 14,
        },

        sizeSmall: {
          fontWeight: 'bold',
          height: 26,
          borderRadius: 15,
          fontSize: 12,
        },

        outlinedPrimary: {
          backgroundColor: 'white',
          ':hover': {
            backgroundColor: '#F1F1F7',
          },
        },

        outlinedSizeMedium: {
          ':hover': {
            borderColor: 'black',
          },

          borderColor: 'black',
        },

        containedSizeMedium: {
          ':hover': {
            borderColor: 'black',
          },

          border: '1px solid;',
          borderColor: 'black',
        },
      },
    },
  },
})

export default theme
